// extracted by mini-css-extract-plugin
module.exports = {"RemoveButton":"styles_RemoveButton__2EcfM","ModalBody":"styles_ModalBody__jelkD","ModalButtons":"styles_ModalButtons__1fU62"};